// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"RD-z","expressButtonContainerWithPayPal":"SD-z","expressButton":"TD-z","or":"UD-z"};